import React from 'react'

function BroadcastIcon({className}) {
  return (
    <svg class={`h-6 w-6 text-inherit ${className}`}  width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <rect x="4" y="6" width="4" height="5" rx="1" />  <line x1="6" y1="4" x2="6" y2="6" />  <line x1="6" y1="11" x2="6" y2="20" />  <rect x="10" y="14" width="4" height="5" rx="1" />  <line x1="12" y1="4" x2="12" y2="14" />  <line x1="12" y1="19" x2="12" y2="20" />  <rect x="16" y="5" width="4" height="6" rx="1" />  <line x1="18" y1="4" x2="18" y2="5" />  <line x1="18" y1="11" x2="18" y2="20" /></svg>
  )
}

export default BroadcastIcon
